import LayoutPage from "../../Components/LayoutPage";
import InformationCard from "./Components/InformationCard";
import AddressCard from "./Components/AddressCard";
import VerificationCard from "./Components/VerificationCard";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../config/api";
import { AsyncContent } from "../../Components/AsyncState";

export default function CustomerInfo() {
  const { customerId } = useParams();
  const [usersData, setUsersData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const fetchUsersData = async () => {
    setLoading(true); setError("");
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/auth/admin/users/${customerId}/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/users/${customerId}/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setUsersData(data);
    } catch (error) {
      console.error("Error fetching account data:", error);
      setError("خطا در دریافت اطلاعات مشتری");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUsersData();
  }, []);
  return (
    <LayoutPage
      activeIndex={5}
      navItems={["مدیریت مشتریان", `مشتری ${customerId}`]}
      childrenClassName="flex-1 min-h-0 flex flex-col items-center gap-5 overflow-auto"
    >
      <AsyncContent loading={loading} error={error} empty={!usersData} onRetry={fetchUsersData}>
      <><InformationCard usersData={usersData} />
      <AddressCard usersData={usersData} />
      <VerificationCard usersData={usersData} /></>
      </AsyncContent>
    </LayoutPage>
  );
}
